import {StylesConfig} from "react-select";

export const COMPONENT_STYLE_OVERRIDE = {
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "2px 8px",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "2px 8px",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "1.3rem",
    borderColor: "transparent",
    boxShadow: "none !important",
    "&:hover": {
      borderColor: "transparent",
    },
    backgroundColor: "transparent",
    minHeight: "33px",
    cursor: "pointer",
  }),
  singleValue: (provided) => ({
    ...provided,
    position: "absolute",
  }),
  placeholder: (provided) => ({
    ...provided,
    position: "absolute",
  }),
  input: () => ({
    input: {
      border: 0,
      outline: 0,
      boxShadow: "none !important",
    },
  }),
} as StylesConfig<{label: string, value: string}, false>;
